/* Handover §4. SPA app registration, PKCE, no client secret.

   Delegated scopes throughout, so the signed-in user's own SharePoint permissions
   still apply and Conditional Access policies apply unchanged. §9 says enforce in
   SharePoint rather than in the UI — delegated auth is what makes that free. */

import { LogLevel, type Configuration } from '@azure/msal-browser';

export const AUTH_MODE = import.meta.env.VITE_AUTH_MODE ?? 'mock';
export const DATA_MODE = import.meta.env.VITE_DATA_MODE ?? 'mock';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    /* localStorage over MSAL's sessionStorage default. A PWA launched from the
       home screen should not demand a sign-in every time. The trade-off is token
       persistence on the device, which Intune app protection policies already
       cover for managed devices (§4). */
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        else if (level === LogLevel.Warning) console.warn(message);
      },
    },
  },
};

/** Acquired at sign-in. */
export const graphScopes = ['User.Read', 'Sites.ReadWrite.All'];

/* No Key Vault scope. There was one, acquired on demand for the reveal button,
   and it went with it: an asset register that asks for permission to read your
   secrets is a question somebody reviewing the app registration would be right
   to ask, and the honest answer was "nothing uses it". */

export const loginRequest = { scopes: graphScopes };

export const siteId = import.meta.env.VITE_SITE_ID ?? '';
